module.exports = __webpack_public_path__ + "5a1359d0c636b71532e76832d144dcc9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-13.png
// module id = 3172
// module chunks = 0